<template>
    <div id="baa-associates" v-if="!generalUser">
        <legend>The business associate who signs</legend>
        <div class="row">
            <div class="form-group col-12 col-md-4">
                <label for="name">BA Company Name</label>
                <input class="form-control" type="text" name="ba_company_name" id="ba_company_name" v-model="inputs.ba_company_name" />
            </div>
            <div class="form-group col-12 col-md-4">
                <label for="name">BA Company Contact Name</label>
                <input class="form-control" type="text" name="ba_contact_name" id="ba_contact_name" v-model="inputs.ba_contact_name" />
            </div>
            <div class="form-group col-12 col-md-4">
                <label for="name">BA Company Contact Phone Number</label>
                <input class="form-control" type="tel" name="ba_contact_phone" id="ba_contact_phone" @input="acceptNumber()" v-model="inputs.ba_contact_phone"  placeholder="888 888 8888" maxlength="12" />
            </div>
        </div>

        <!-- Direction is implied by the module (a CE VRM customer is the CE, sending to a business associate), so we no longer ask. Values submit as hidden fields. -->
        <input type="hidden" name="signed_as" :value="inputs.signed_as || 'ce'">
        <input type="hidden" name="signed_as_third_party" :value="inputs.signed_as_third_party || 'ba'">
        <!-- MSD-392: the Master Password gates the BA's public view of this BAA.
             Required unless explicitly waived. Masked (was type="text", i.e. shown
             in the clear on screen). -->
        <div class="row">
            <div class="form-group col-12 col-md-6">
                <label for="password">Master Password</label>
                <input class="form-control" type="password" id="password" name="password"
                       autocomplete="new-password"
                       :disabled="!!inputs.allow_no_password"
                       v-model="inputs.password" />
                <small class="form-text text-muted">
                    A Master Password is a short passcode the business associate types to open this BAA from the link in their invitation email, so only they can view the agreement. We include it automatically in that email. It is not their Medcurity login. If this business associate can't use a password, tick "Send without a Master Password" below to skip it.
                </small>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="allow_no_password"
                           name="allow_no_password" value="1" v-model="inputs.allow_no_password" />
                    <label class="custom-control-label" for="allow_no_password">
                        Send without a Master Password
                    </label>
                </div>
                <div v-if="inputs.allow_no_password" class="mt-2">
                    <label for="no_password_reason">Why is no password needed? <span class="text-muted">(optional)</span></label>
                    <input class="form-control" type="text" id="no_password_reason"
                           name="no_password_reason" maxlength="255"
                           v-model="inputs.no_password_reason" />
                    <small class="form-text text-muted">
                        Anyone with the link will be able to open this BAA without a password.
                    </small>
                </div>
            </div>
        </div>

        <div class="row"><div class="col-12"><small class="form-text text-muted" style="margin-bottom:4px;">Enter the email of the person at the business associate who will sign. We email them a secure link (with the Master Password above) to review and sign the BAA.</small></div></div>
        <div class="row" ref="associateEmailContainer">
            <div v-if="!inputs.associates.length" class="form-group col-12 col-md-6 associate-email">
                <label for="associate_email_1">Business associate&rsquo;s email #<span>1</span></label>
                <div class="d-flex">
                    <input class="form-control flex-grow-0" type="email" id="associate_email_1" name="associate_email[]">
                    <button class="btn btn-danger flex-grow-1 delete-associate-email">&times;</button>
                </div>
            </div>
            <div v-else v-for="(associate, index) in inputs.associates" class="form-group col-12 col-md-6 associate-email">
                <label :for="`associate_email_${index + 1}`">Business associate&rsquo;s email #<span>{{ index + 1 }}</span></label>
                <div class="d-flex">
                    <input class="form-control flex-grow-0" type="email" :id="`associate_email_${index + 1}`"
                           name="associate_email[]" :value="associate">
                    <button class="btn btn-danger flex-grow-1 delete-associate-email">&times;</button>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <button class="btn btn-secondary" @click.prevent="addAssociateEmail"><i class="fa fa-envelope"></i>&nbsp;Add Email</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: "BaaMedcurityAssociates",
        computed:{
            ...mapState('baaForm', [
                'inputs',
                'generalUser'
            ])
        },
        mounted(){
            console.log('generalUser: ' + this.generalUser);
            this.bindEvents()
        },
        methods:{
            acceptNumber() {
                console.log('acceptnumber');
                var x = this.inputs.ba_contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                this.inputs.ba_contact_phone = !x[2] ? x[1] : x[1] + ' ' + x[2] + (x[3] ? '-' + x[3] : '');
            },
            bindEvents(){
                window.onload = ()=>{
                    window.$(document).on('click', 'button.delete-associate-email', this.removeAssociateEmail)
                }
            },
            addAssociateEmail(){
                let associateEmailInputs = document.getElementsByClassName('associate-email')

                if(!associateEmailInputs){
                    console.log('Missing associate email inputs.');
                    return;
                }

                let newAssociateEmail = associateEmailInputs[ associateEmailInputs.length - 1 ].cloneNode(true)
                let clonedLabel = newAssociateEmail.getElementsByTagName('label')[0],
                    clonedLabelSpan = clonedLabel.getElementsByTagName('span')[0],
                    clonedInput = newAssociateEmail.getElementsByTagName('input')[0]

                clonedLabelSpan.innerText = (parseInt(clonedLabelSpan.innerText) + 1).toString()

                let newId = clonedLabel.getAttribute('for').split('_')


                newId[ newId.length - 1 ] = clonedLabelSpan.innerText
                newId = newId.join('_')

                clonedLabel.setAttribute('for', newId)
                clonedInput.id = newId
                clonedInput.value = ''


                this.$refs.associateEmailContainer.append(newAssociateEmail)
            },
            removeAssociateEmail(e){
                e.preventDefault()

                if(document.getElementsByClassName('associate-email').length <= 1){
                    alert('One associate email field needs to be available.');
                    return;
                }

                e.target.closest('.associate-email').remove()
            }
        }
    }
</script>

<style scoped>

</style>
